import { Breadcrumbs, Link } from '@mui/material';
import { Link as NextLink } from 'components/common/Link';

import { deprecatedColors } from 'styles/theme/deprecatedColors';
import { useOrganisationPersonalWebshop } from 'hooks/useOrganisationPersonalWebshop';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { Breadcrumb } from '../../../generated/graphql';

type BreadcrumbProps = {
    breadcrumbs?: Breadcrumb[];
};

export function CustomBreadcrumbs({ breadcrumbs }: BreadcrumbProps) {
    const { t } = useServerTranslation();

    return (
        <Breadcrumbs separator="/" aria-label="breadcrumb" sx={{ marginBottom: 5 }}>
            <Link
                href="/"
                color={deprecatedColors.gray2}
                component={NextLink}
            >
                {t('common.breadcrumbs.home')}
            </Link>
            {breadcrumbs ? breadcrumbs.map((breadcrumb, index) => (
                <BreadcrumbLink key={index} {...breadcrumb} />
            )) : null}
        </Breadcrumbs>
    );
}

function BreadcrumbLink({ href, title }: Breadcrumb) {
    const { baseUrl } = useOrganisationPersonalWebshop();
    const breadcrumbHref = href.startsWith('/') ? href : `/${href}`;

    return (
        <Link
            component={NextLink}
            key={href}
            href={`${baseUrl}${breadcrumbHref}`}
            color={deprecatedColors.gray2}
        >
            <div dangerouslySetInnerHTML={{ __html: title }} />
        </Link>
    );
}
